module.exports = __webpack_public_path__ + "static/media/Dream_AE_EN.b40c726d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_AE_EN.png
// module id = 550
// module chunks = 0